import styled from 'styled-components';
import { RoundedButton } from 'Components/Styles/Buttons/RoundedButton';

export const CircularButton = styled(RoundedButton)`
    min-width: 0;
    padding: 0.25em;
`; 